import { render } from "./Platform.vue?vue&type=template&id=3172aa4e"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"

import "./Platform.vue?vue&type=style&index=0&id=3172aa4e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__